import { createContext } from "react";

const currentAdminContext = createContext({
  currentAdmin: null,
  login: (admin) => {},
  logout: () => {},
});

export default currentAdminContext;
